import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'

import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import { browserHistory } from 'react-router'
import ReduxThunk from 'redux-thunk'
import { syncHistoryWithStore } from 'react-router-redux'
import reducers from './entities'
import Routes from './routes'
import viewportBuggyfill from 'viewport-units-buggyfill'

const store = createStore(reducers, applyMiddleware(ReduxThunk))

// This buggyfill fixes the issue with vh/vw/vmin/vmax not working on mobile browsers
viewportBuggyfill.init()

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store)

ReactDOM.render(
  <Provider store={store}>
    <Routes history={history} />
  </Provider>,
  document.getElementById('root')
)
export { store }



// WEBPACK FOOTER //
// ./src/index.js